export default __webpack_public_path__ + "static/media/shane-mclendon-9jPJrfLTBi0-unsplash Large.57b43ad7.jpg";